export const GET_MASTER_COURSES_COUNTRIES_REQUEST = 'GET_MASTER_COURSES_COUNTRIES_REQUEST';
export const GET_MASTER_COURSES_COUNTRIES_SUCCESS = 'GET_MASTER_COURSES_COUNTRIES_SUCCESS';
export const GET_MASTER_COURSES_COUNTRIES_FAILURE = 'GET_MASTER_COURSES_COUNTRIES_FAILURE';

export const getMasterCoursesCountries = () =>
    ({ type: GET_MASTER_COURSES_COUNTRIES_REQUEST });

export const getMasterCoursesCountriesSuccess = countries =>
    ({ type: GET_MASTER_COURSES_COUNTRIES_SUCCESS, countries });

export const getMasterCoursesCountriesFailure = () =>
    ({ type: GET_MASTER_COURSES_COUNTRIES_FAILURE });

export const GET_MASTER_COURSES_BY_COUNTRY_REQUEST = 'GET_MASTER_COURSES_BY_COUNTRY_REQUEST';
export const GET_MASTER_COURSES_BY_COUNTRY_SUCCESS = 'GET_MASTER_COURSES_BY_COUNTRY_SUCCESS';
export const GET_MASTER_COURSES_BY_COUNTRY_FAILURE = 'GET_MASTER_COURSES_BY_COUNTRY_FAILURE';

export const getMasterCoursesByCountry = (countryCode = 'AUS') =>
    ({ type: GET_MASTER_COURSES_BY_COUNTRY_REQUEST, countryCode });

export const getMasterCoursesByCountrySuccess = masterCourses =>
    ({ type: GET_MASTER_COURSES_BY_COUNTRY_SUCCESS, masterCourses });

export const getMasterCoursesByCountryFailure = () =>
    ({ type: GET_MASTER_COURSES_BY_COUNTRY_FAILURE });

export const GET_SUBJECTS_REQUEST = 'GET_SUBJECTS_REQUEST';
export const GET_SUBJECTS_SUCCESS = 'GET_SUBJECTS_SUCCESS';
export const GET_SUBJECTS_FAILURE = 'GET_SUBJECTS_FAILURE';

export const getSubjects = () =>
    ({ type: GET_SUBJECTS_REQUEST });

export const getSubjectsSuccess = subjects =>
    ({ type: GET_SUBJECTS_SUCCESS, subjects });

export const getSubjectsFailure = () =>
    ({ type: GET_SUBJECTS_FAILURE });


export const CHANGE_SUBJECT = 'CHANGE_SUBJECT';

export const changeSubject = productId => ({ type: CHANGE_SUBJECT, productId });

export const CHANGE_COUNTRY = 'CHANGE_COUNTRY';

export const changeCountry = countryCode => ({ type: CHANGE_COUNTRY, countryCode });

export const FILTER_MASTER_COURSES = 'FILTER_MASTER_COURSES';

export const filterMasterCourses = searchFilter => ({ type: FILTER_MASTER_COURSES, searchFilter });

export const GET_MASTER_COURSES_REQUEST = 'GET_MASTER_COURSES_REQUEST';
export const GET_MASTER_COURSES_SUCCESS = 'GET_MASTER_COURSES_SUCCESS';
export const GET_MASTER_COURSES_FAILURE = 'GET_MASTER_COURSES_FAILURE';

export const getMasterCourses = accessStatus =>
    ({ type: GET_MASTER_COURSES_REQUEST, accessStatus });

export const getMasterCoursesSuccess = masterCourses =>
    ({ type: GET_MASTER_COURSES_SUCCESS, masterCourses });

export const getMasterCoursesFailure = () =>
    ({ type: GET_MASTER_COURSES_FAILURE });

export const RESET_MASTER_COURSES = 'RESET_MASTER_COURSES';

export const resetMasterCourses = () =>
    ({ type: RESET_MASTER_COURSES });



// WEBPACK FOOTER //
// ./app/containers/master-courses/actions.js